import React from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import { Box } from "@mui/system";
import {
  FormControl,
  FormHelperText,
  Grid,
  MenuItem,
  Typography,
} from "@mui/material";
import {
  StyledSelect,
  StyledTextField,
} from "../../../customComponents/styled/styledInputs";
import { StyledLoadingButton } from "../../../customComponents/styled/styledButtons";
import { useUpdateDepartmentMutation } from "./departmentsApiSlice";
import { useGetTeacherQuery } from "../../staff/staffApiSlice";
import toast from "../../../../helpers/toast";

const departmentFormValidation = yup.object({
  name: yup.string().required("Required"),
  head_title: yup.string().required("Required"),
});

function EditDepartmentForm({ item, setFocusedItem, setEditDepartment }) {
  const [updateDepartment, { isLoading }] = useUpdateDepartmentMutation();
  const { data: teachers } = useGetTeacherQuery("all");

  const departmentForm = useFormik({
    initialValues: {
      id: item?.id,
      name: item?.name,
      head_title: item?.head_title,
      head_id: item?.head?.id ?? "",
    },
    enableReinitialize: true,
    validationSchema: departmentFormValidation,
    onSubmit: async (values) => {
      try {
        await updateDepartment(values).unwrap();
        toast.success("Department updated successfully");
        departmentForm.resetForm();
        setFocusedItem(null);
        setEditDepartment(false);
      } catch (error) {
        toast.error(error?.message || "Something went wrong");
      }
    },
  });

  return (
    <>
      <Box className="paperHeader">
        <Typography variant="formHeading">Edit Department</Typography>
      </Box>
      <Box className="paperBody">
        <form onSubmit={departmentForm.handleSubmit}>
          <Grid container columnSpacing={1} rowSpacing={2}>
            <Grid item xs={12}>
              <FormControl error fullWidth>
                <Typography variant="formSubHeading">Department Name</Typography>
                <StyledTextField
                  autoFocus
                  id="name"
                  name="name"
                  value={departmentForm.values.name}
                  onChange={departmentForm.handleChange}
                  error={
                    departmentForm.touched.name &&
                    Boolean(departmentForm.errors.name)
                  }
                />
                <FormHelperText variant="error">
                  {departmentForm.touched.name && departmentForm.errors.name}
                </FormHelperText>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <FormControl error fullWidth>
                <Typography variant="formSubHeading">
                  HEAD'S TITLE (E.G: HEAD OF DEPARTMENT)
                </Typography>
                <StyledTextField
                  id="head_title"
                  name="head_title"
                  value={departmentForm.values.head_title}
                  onChange={departmentForm.handleChange}
                  error={
                    departmentForm.touched.head_title &&
                    Boolean(departmentForm.errors.head_title)
                  }
                />
                <FormHelperText variant="error">
                  {departmentForm.touched.head_title &&
                    departmentForm.errors.head_title}
                </FormHelperText>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <FormControl fullWidth>
                <Typography variant="formSubHeading">SELECT STAFF</Typography>
                <StyledSelect
                  displayEmpty
                  id="head_id"
                  name="head_id"
                  value={departmentForm.values.head_id}
                  onChange={departmentForm.handleChange}
                >
                  <MenuItem value="" disabled>
                    <em>select staff</em>
                  </MenuItem>
                  {teachers?.map((teacher, i) => (
                    <MenuItem value={teacher?.user_id} key={i}>
                      {teacher?.first_name} {teacher?.last_name}
                    </MenuItem>
                  ))}
                </StyledSelect>
              </FormControl>
            </Grid>
            <Grid item xs={12} textAlign="right">
              <StyledLoadingButton loading={isLoading} type="submit">
                update
              </StyledLoadingButton>
            </Grid>
          </Grid>
        </form>
      </Box>
    </>
  );
}

export default EditDepartmentForm;
